import { StringHelper } from "../../utilities/contracts/string-helper";
import { StorageValueHelper } from "./storage-value-helper.model";
import * as i0 from "@angular/core";
export class SessionService {
    put(key, value) {
        StringHelper.throwIsAvailableError(key, "key");
        const stringValue = StorageValueHelper.create(value);
        window.sessionStorage.setItem(key, stringValue);
    }
    get(key, defaultValue) {
        StringHelper.throwIsAvailableError(key, "key");
        const value = window.sessionStorage.getItem(key);
        const realValue = StringHelper.isAvailable(value) ? StorageValueHelper.get(value) : defaultValue;
        return realValue;
    }
    delete(key = "") {
        window.sessionStorage.removeItem(key);
    }
    clear() {
        window.sessionStorage.clear();
    }
}
SessionService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SessionService_Factory() { return new SessionService(); }, token: SessionService, providedIn: "root" });
